// global
import React, { Component, memo } from 'react';
import PropTypes from 'prop-types';
// api
import * as BusinessPartners from 'app/api/businessPartners';
// views
import NestedDropdown from 'app/components/commons/dropdown/nested/NestedDropdown';
import CustomDropdown from 'app/components/commons/dropdown/CustomDropdown';
import ErrorLabel from 'app/components/commons/label/ErrorLabel';
import { sortString } from 'app/utils';

class BusinessPartnerDropdown extends Component {
  state = {
    loading: true,
    options: []
  };

  componentDidMount() {
    BusinessPartners.getBusinessPartners()
      .then(this.onLoadBusinessPartnerSuccess)
      .catch(this.onLoadClientFail);
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  onLoadBusinessPartnerSuccess = businessPartners => {
    businessPartners = businessPartners.map(businessPartner => ({
      text: businessPartner.name,
      value: parseInt(businessPartner.id)
    }));
    businessPartners.sort((a, b) => sortString(a.text, b.text));

    const options = [{ text: '-', value: null }, ...businessPartners];

    if (this._isMounted) {
      this.setState({
        loading: false,
        options
      });
    }
  };

  onLoadClientFail = () => {
    if (this._isMounted) {
      this.setState({
        loading: false,
        options: []
      });
    }
  };

  render() {
    const { options, loading } = this.state;
    const {
      nested,
      value,
      onChange,
      error,
      isForm,
      width,
      required,
      disabled,
      showLabel,
      label,
      placeholder,
      styleName
    } = this.props;

    if (nested) {
      return (
        <NestedDropdown
          options={options}
          name={label}
          onOptionSelection={this.props.onOptionSelection}
        />
      );
    }

    return (
      <CustomDropdown
        loading={loading}
        options={options}
        value={value}
        onChange={onChange}
        error={error ? true : false}
        isForm={isForm}
        width={width}
        required={required}
        placeholder={placeholder}
        disabled={disabled}
        styleName={styleName}
        label={showLabel && <ErrorLabel label={label} error={error} />}
        selection
      />
    );
  }
}

BusinessPartnerDropdown.propTypes = {
  nested: PropTypes.bool,
  onOptionSelection: PropTypes.func,
  value: PropTypes.any,
  onChange: PropTypes.func,
  error: PropTypes.string,
  isForm: PropTypes.bool,
  width: PropTypes.number,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  showLabel: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  styleName: PropTypes.oneOf(['styleModal', 'styleReport', 'styleReportGeneration'])
};

BusinessPartnerDropdown.defaultProps = {
  isForm: true,
  showLabel: true,
  label: 'Parceiro de Negócio',
  placeholder: 'Parceiro de Negócio',
  styleName: 'styleModal'
};

export default memo(BusinessPartnerDropdown);
